/*
 * Cart add-ons (snippets/cart-addons.liquid).
 * - Dismiss: the × hides the whole block for the browser session. The class lives on <html> so
 *   it survives the cart drawer re-rendering.
 * - View panel: the thumbnail and name open a panel over the cart with the sock's photos, sizes
 *   and other colours (sections/api-cart-addon-panel.liquid). In the drawer it is mounted inside
 *   the drawer, so the cart stays open underneath; on /cart it is mounted to <body>. The links
 *   stay real links without JS.
 * - Undo: after a one-tap add from the block or the panel, the slot rendered next to the block
 *   (snippets/cart-line-items.liquid) says "Added …, M · Undo" until the cart changes again.
 */
(function () {
  var storageKey = 'francie:cart-addons-dismissed';
  var dismissedClass = 'cart-addons--dismissed';

  try {
    if (window.sessionStorage.getItem(storageKey)) {
      document.documentElement.classList.add(dismissedClass);
    }
  } catch (e) {}

  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-cart-addons-dismiss]')) {
      return;
    }

    event.preventDefault();
    document.documentElement.classList.add(dismissedClass);

    try {
      window.sessionStorage.setItem(storageKey, '1');
    } catch (e) {}
  });

  /* View panel */

  var panel = null; // the open panel element, or null
  var trigger = null; // element to return focus to
  var panelFor = null; // handle of the suggestion the panel was opened from
  var request = 0; // latest content request; older responses are dropped
  var drawerObserver = null;
  var focusableSelector =
    'a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function scrollLock() {
    return window.themeVendor && window.themeVendor.BodyScrollLock;
  }

  function sectionUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + encodeURIComponent(handle) + '?section_id=api-cart-addon-panel';
  }

  function buildPanel(inDrawer) {
    var el = document.createElement('div');
    el.className = 'cart-addon-panel' + (inDrawer ? '' : ' cart-addon-panel--page');
    el.setAttribute('data-cart-addon-panel', '');
    // Lets the theme's add buttons reload the cart instead of opening the product popdown.
    el.setAttribute('data-add-inside-cart', '');
    el.setAttribute('data-add-action-wrapper', '');
    el.setAttribute('data-error-boundary', '');
    el.innerHTML =
      '<div class="cart-addon-panel__underlay" data-cart-addon-panel-close></div>' +
      '<div class="cart-addon-panel__sheet" role="dialog" aria-modal="true" aria-labelledby="cart-addon-panel-title" tabindex="-1">' +
      '<div class="cart-addon-panel__scroll" data-cart-addon-panel-scroll>' +
      '<div class="cart-addon-panel__top"><button type="button" class="cart-addon-panel__back" data-cart-addon-panel-close>&larr; Back to cart</button></div>' +
      '<p class="cart-addon-panel__loading" id="cart-addon-panel-title">Loading…</p>' +
      '</div>' +
      '<div data-error-display class="add-action-errors"></div>' +
      '</div>';
    return el;
  }

  function loadContent(handle, onLoaded) {
    var id = ++request;
    window
      .fetch(sectionUrl(handle))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (html) {
        if (id !== request || !panel) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var content = doc.querySelector('[data-api-content]');
        if (!content) throw new Error('no panel content');
        var scroller = panel.querySelector('[data-cart-addon-panel-scroll]');
        scroller.innerHTML = content.innerHTML;
        scroller.scrollTop = 0;
        // Adds of another colour still count as this suggestion (snippets/cart-addons.liquid).
        Array.prototype.forEach.call(panel.querySelectorAll('[data-cart-addon-for]'), function (input) {
          input.value = panelFor;
        });
        if (onLoaded) onLoaded();
      })
      .catch(function () {
        // Fall back to the product page, as without JS.
        if (id === request && panel) window.location.href = '/products/' + encodeURIComponent(handle);
      });
  }

  // The panel clips the sheet while it slides in, and a plain focus() scrolls that clipped box
  // sideways to reveal it (on iPhone the sheet flashed on the left first). Older iOS ignores
  // preventScroll, hence the reset.
  function focusInPanel(el) {
    el.focus({preventScroll: true});
    if (panel) panel.scrollLeft = 0;
  }

  function openPanel(handle, triggerEl) {
    if (panel) closePanel({restoreFocus: false});

    var drawer = triggerEl.closest('[data-drawer="drawer-cart"]');
    var mount = (drawer && drawer.querySelector('.drawer__content')) || document.body;
    trigger = triggerEl;
    panelFor = handle;
    panel = buildPanel(Boolean(drawer));
    mount.appendChild(panel);

    var sheet = panel.querySelector('.cart-addon-panel__sheet');
    var scroller = panel.querySelector('[data-cart-addon-panel-scroll]');
    // On iOS the lock cancels a downward drag at the top of the scroller, which also catches a
    // sideways swipe through the photos.
    if (scrollLock()) {
      scrollLock().disableBodyScroll(scroller, {
        allowTouchMove: function (el) {
          return Boolean(el.closest && el.closest('.cart-addon-panel__media'));
        },
      });
    }

    // Next frame, so the slide-in transition runs.
    window.requestAnimationFrame(function () {
      if (panel) panel.classList.add('is-open');
    });
    focusInPanel(sheet);

    if (drawer) {
      drawerObserver = new MutationObserver(function () {
        if (!drawer.classList.contains('drawer--visible')) closePanel({restoreFocus: false});
      });
      drawerObserver.observe(drawer, {attributes: true, attributeFilter: ['class']});
    }

    loadContent(handle, function () {
      var back = panel.querySelector('.cart-addon-panel__back');
      if (back) focusInPanel(back);
    });
  }

  // Another colour: swap the panel's content in place, keeping the suggestion it belongs to.
  function swapPanel(handle) {
    loadContent(handle, function () {
      var current = panel.querySelector('[data-cart-addon-colour][aria-current="true"]');
      if (current) focusInPanel(current);
    });
  }

  function closePanel(options) {
    if (!panel) return;
    var restoreFocus = !options || options.restoreFocus !== false;
    var closing = panel;
    var scroller = closing.querySelector('[data-cart-addon-panel-scroll]');

    panel = null;
    panelFor = null;
    request++;
    if (drawerObserver) {
      drawerObserver.disconnect();
      drawerObserver = null;
    }
    if (scrollLock()) scrollLock().enableBodyScroll(scroller);

    closing.classList.remove('is-open');
    window.setTimeout(function () {
      closing.remove();
    }, 300);

    if (restoreFocus && trigger) {
      var target = trigger.isConnected ? trigger : null;
      if (!target) {
        var handle = trigger.getAttribute('data-cart-addon-view');
        target = document.querySelector('.cart-addon__image[data-cart-addon-view="' + handle + '"]');
      }
      if (target) target.focus();
    }
    trigger = null;
  }

  document.addEventListener('click', function (event) {
    var view = event.target.closest('[data-cart-addon-view]');
    if (view && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      openPanel(view.getAttribute('data-cart-addon-view'), view);
      return;
    }
    if (!panel) return;
    if (event.target.closest('[data-cart-addon-panel-close]')) {
      event.preventDefault();
      closePanel();
      return;
    }
    var colour = event.target.closest('[data-cart-addon-colour]');
    if (colour && panel.contains(colour) && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault();
      if (colour.getAttribute('aria-current') !== 'true') swapPanel(colour.getAttribute('data-cart-addon-colour'));
    }
  });

  // Hovering or focusing a colour circle previews its name in the legend, as on product pages.
  function previewColour(event) {
    if (!panel) return;
    var label = panel.querySelector('[data-cart-addon-colour-name]');
    if (!label) return;
    var colour = event.target.closest && event.target.closest('[data-cart-addon-colour]');
    var leaving = event.type === 'mouseout' || event.type === 'focusout';
    label.textContent = colour && !leaving ? colour.getAttribute('data-colour-name') : label.getAttribute('data-current');
  }
  ['mouseover', 'mouseout', 'focusin', 'focusout'].forEach(function (type) {
    document.addEventListener(type, previewColour);
  });

  // Capture phase, so Escape and Tab never reach the cart drawer's own handlers while the panel
  // is open (the drawer closes on Escape and traps focus across the whole drawer).
  function onKey(event) {
    if (!panel) return;
    if (event.key === 'Escape') {
      event.stopPropagation();
      if (event.type === 'keyup') closePanel();
      return;
    }
    if (event.key !== 'Tab' || event.type !== 'keydown') return;

    var sheet = panel.querySelector('.cart-addon-panel__sheet');
    var items = Array.prototype.filter.call(sheet.querySelectorAll(focusableSelector), function (el) {
      return el.offsetParent !== null;
    });
    event.stopPropagation();
    if (!items.length) {
      event.preventDefault();
      focusInPanel(sheet);
      return;
    }
    var first = items[0];
    var last = items[items.length - 1];
    var inside = sheet.contains(document.activeElement);
    if (event.shiftKey && (!inside || document.activeElement === first || document.activeElement === sheet)) {
      event.preventDefault();
      focusInPanel(last);
    } else if (!event.shiftKey && (!inside || document.activeElement === last)) {
      event.preventDefault();
      focusInPanel(first);
    }
  }
  document.addEventListener('keydown', onKey, true);
  document.addEventListener('keyup', onKey, true);

  // The cart re-rendered (including after adding from the panel): the panel's job is done.
  document.addEventListener('theme:cart:reload', function () {
    closePanel({restoreFocus: false});
  });

  /* Undo */

  var pendingUndo = null; // add tapped, not yet confirmed
  var armedUndo = null; // add succeeded (the theme reloads the cart); waiting for the re-render
  var staleSlots = []; // undo slots from before that re-render
  var undoText = {
    failed: "Couldn't undo, please remove it from your cart",
  };

  // Capture phase: the theme's add button stops the click's default and never submits the form.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('[data-add-to-cart]');
      if (!button) return;
      var scope = button.closest('.cart-addon, .cart-addon-panel');
      var form = button.closest('form');
      var id = form && form.querySelector('input[name="id"]');
      if (!scope || !id) {
        pendingUndo = null;
        return;
      }
      var title = scope.querySelector('.upsell__title');
      var label = button.querySelector('.btn-state-ready');
      pendingUndo = {
        variantId: Number(id.value),
        name: title ? title.textContent.trim() : '',
        size: label ? label.textContent.replace('+', '').trim().charAt(0) : '',
        at: Date.now(),
      };
    },
    true
  );

  // The theme dispatches theme:cart:reload only after a successful add.
  document.addEventListener('theme:cart:reload', function () {
    // A failed add never reloads; don't let a later, unrelated reload pick it up.
    if (!pendingUndo || Date.now() - pendingUndo.at > 15000) {
      pendingUndo = null;
      return;
    }
    armedUndo = pendingUndo;
    pendingUndo = null;
    staleSlots = Array.prototype.slice.call(document.querySelectorAll('[data-cart-addons-undo]'));
  });

  function focusLost() {
    return !document.activeElement || document.activeElement === document.body;
  }

  // The slot is a live region: it's shown empty first and filled a moment later, so screen
  // readers announce it. If the add removed the focused button, focus moves to Undo.
  function fillSlot(slot, undo, takeFocus) {
    slot.innerHTML = '';
    slot.hidden = false;
    window.setTimeout(function () {
      slot.appendChild(document.createTextNode('Added ' + undo.name + (undo.size ? ', ' + undo.size : '') + ' · '));
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'cart-addons-undo__button';
      button.setAttribute('data-cart-addons-undo-button', String(undo.variantId));
      button.textContent = 'Undo';
      slot.appendChild(button);
      if (takeFocus && focusLost() && slot.getClientRects().length) button.focus();
    }, 100);
  }

  // Show the confirmation in the freshly rendered slot(s). Any later re-render renders a new,
  // hidden slot, which is what clears it.
  new MutationObserver(function () {
    if (!armedUndo) return;
    var fresh = Array.prototype.filter.call(document.querySelectorAll('[data-cart-addons-undo]'), function (slot) {
      return staleSlots.indexOf(slot) === -1;
    });
    if (!fresh.length) return;
    var takeFocus = focusLost();
    fresh.forEach(function (slot) {
      fillSlot(slot, armedUndo, takeFocus);
    });
    armedUndo = null;
    staleSlots = [];
  }).observe(document.documentElement, {childList: true, subtree: true});

  function setSlots(text) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-addons-undo]'), function (slot) {
      if (text) {
        slot.textContent = text;
      } else {
        slot.innerHTML = '';
        slot.hidden = true;
      }
    });
  }

  function postJson(url, body) {
    return window
      .fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(body),
      })
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cart-addons-undo-button]');
    if (!button) return;
    event.preventDefault();
    var variantId = Number(button.getAttribute('data-cart-addons-undo-button'));
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    button.disabled = true;

    window
      .fetch(root + 'cart.js', {headers: {Accept: 'application/json'}})
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (cart) {
        // Only ever the pair this block added: same variant, tagged _source.
        var line = cart.items.filter(function (item) {
          return item.variant_id === variantId && item.properties && item.properties._source === 'cart-addons';
        })[0];
        if (!line) {
          setSlots('');
          return null;
        }
        return postJson(root + 'cart/change.js', {id: line.key, quantity: line.quantity - 1}).then(function (updated) {
          setSlots('');
          document.dispatchEvent(new CustomEvent('theme:cart:change', {detail: {cart: updated}, bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:reload', {bubbles: true}));
        });
      })
      .catch(function () {
        setSlots(undoText.failed);
      });
  });
})();
